export default "__VITE_ASSET__DZTgCRUc__"